
/**
 * @ngdoc directive
 * @name news
 *
 * @description
 * News
 */
module.directive('news', function () {
    'use strict';
    return {
        restrict: 'E',
        scope: {
            label: '@',
            content: '='
        },
        controller: ['$scope', '$filter', function ($scope, $filter) {
            if ($scope.content) {
                $scope.content.slug = $filter('slugify')($scope.content.title);
            }
        }],
        template:
                '<div class="aqua-news" ng-if="content">' +
                '  <div class="grid-main">' +
                '    <h2 class="grid grid-center"><span class="aqua-news--title">{{label}}</span></h2>' +

                '    <div class="grid grid-right">' +
                '      <div class="aqua-news--panel">' +

                /* picture*/
                '        <div class="aqua-news--figure">' +
                '          <img class="aqua-news--picture" aqua-src="{{content.field_image.src}}" alt="{{content.field_image.alt}}" />' +
                '        </div>' +

                /* content*/
                '        <div class="aqua-news--content">' +
                '          <h2 class="aqua-news--subtitle"><a ui-sref="newsdetail({id: content.nid, slug: content.slug})">{{content.title}}</a></h2>' +
                '          <p class="aqua-news--text">{{content.field_teaser}}</p>' +
                '          <p><a ui-sref="newsdetail({id: content.nid, slug: content.slug})" class="aqua-news--link">En savoir plus</a></p>' +
                '        </div>' +

                '      </div>' +
                '    </div>' +

                '  </div>' +
                '</div>'
    };
});
